import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import profileImg2 from '../Assets/Images/temp-img.png';
import dashboardIcon from '../Assets/Icons/dashboard.png';
import tasksIcon from '../Assets/Icons/check-list.png';
import billingIcon from '../Assets/Icons/layer.png';
import settingIcon from '../Assets/Icons/setting-2.png';
import logoutIcon from '../Assets/Icons/user.png';
import userIcon from '../Assets/Icons/user-s.png';
import logo from '../Assets/Images/sideMenuLogo.png';
import menuIcon from '../Assets/Icons/chevron-down-arrow.png';
import downArrowIcon from '../Assets/Icons/chevron-down.png';
import pluseIcon from '../Assets/Icons/pluse-s.png';
import cardIcon from '../Assets/Icons/qns-mark.png';
import DocumentIcon from '../Assets/Icons/crose-arrow.png';
import setting2Icon from '../Assets/Icons/setting-s.png';
import searchIcon from '../Assets/Icons/search.png';
import { postData, postDataLogin } from '../ApiServices/ApiService';
import { REFRESH_TOKEN, PUNCH_STATUS_API, UPLOAD_EMP_PROFILE_URL } from '../ApiServices/BaseURL';
import sideMenu from '../Assets/Icons/side-menu.png';
import { forwardRef } from 'react';
import { logFrontendException, logOutApiCall } from '../Utils/Exception';
import { convertGMTToLocal } from '../Utils/Validation';
import { useTheme } from '../GlobalContext/GlobalContext';
import galleryIcon from '../Assets/Icons/galleryIcon.png';
import removeIcon from '../Assets/Icons/rejected.png';
import cameraIcon from '../Assets/Icons/cameraIcon.png'
import Loader from './Loader';


const Sidebar = forwardRef(({ onValueChange, isOverlay, toggleOverlay }, ref) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuShow, setIsMenuShow] = useState(false)
  const [userInfo, setUserInfo] = useState({});
  const [userPermissions, setUserPermissions] = useState({});
  const [punchError, setPunchError] = useState('');
  const [punchSuccess, setPunchSuccess] = useState('');
  const [punchLoading, setPunchLoading] = useState(false);
  const [isPunchedIn, setIsPunchedIn] = useState(false);
  const [punchTime, setPunchTime] = useState(null);
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const { setIsLoginPopup } = useTheme();
  const [activeSubDropdown, setActiveSubDropdown] = useState(null);
  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
    setUserInfo(storedUserInfo);
    setUserPermissions(storedUserInfo?.user_permissions || {});
    setImageSrc(storedUserInfo?.logo_url)
    getProfileImage();
  }, []);

  useEffect(() => {
    if (screenSize.width <= 958) {
      //console.log('window.innerWidth:-----',screenSize)

      setIsMenuShow(true)
    }

  }, [screenSize])

  const handleNav = (path) => {
    navigate(path);
  };

  const handleLogout = () => {
    localStorage.removeItem('userRole');
    localStorage.removeItem('_userInfo_');
    localStorage.removeItem('whatsAppStatus');
    // localStorage.clear();
    navigate('/login');
  };

  const handlePunch = async (emp_id) => {
    try {
      setPunchError('');
      setPunchSuccess('');
      setPunchLoading(true);

      const payload = {
        action: 'punch_logout',
        emp_id_auth: emp_id,
        emp_punch: 2,
      };

      const response = await postData(PUNCH_STATUS_API, payload);
      const responseData = await response.json();

      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message?.toLowerCase() === 'success') {
            const punchActivity = responseData?.dataJ?.punch_activity;
            const createdAt = convertGMTToLocal(responseData?.dataJ?.created_at, "yyyy-MM-dd HH:mm:ss");

            setIsPunchedIn(punchActivity === 1);
            setPunchTime(createdAt.split(" ")[1]);
          } else {
            setPunchError(responseData?.info || 'Punch action failed.');
            logFrontendException(emp_id, 'PunchInOutPage', 'handlePunchInOut', responseData?.info || '');
          }
        } else {
          setPunchError(responseData?.info || 'Punch status fetch failed.');
          logFrontendException(emp_id, 'PunchInOutPage', 'handlePunchInOut', responseData || '');
        }
      } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setPunchError('Unauthorized access. Your session may have expired. Please log in again.');
        setIsLoginPopup(true)
      }
      else {
        setPunchError('Unexpected error occurred. Please try again later.');
        logFrontendException(emp_id, 'PunchInOutPage', 'handlePunchInOut', response || '');
      }
    } catch (err) {
      setPunchError('Failed to fetch punch status. Please check your network connection and try again.');
      logFrontendException(null, 'PunchInOutPage', 'handlePunchInOutCatch', err || '');
    } finally {
      setPunchLoading(false); // Hide the loader
    }
  };

  const logout = () => {
    const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
    const emp_id = storedUserInfo?.emp_id;
    logOutApiCall(emp_id, 'manual logout' );
    handleLogout();
    // handlePunch(emp_id);
  };

  const equivalentPaths = {
    "/services/gst-services": ["/tasklist"],
    "/clientlist": ["/manage-clients"],
    "/services/manage-group": ["/manage-group-details"],
    "/bills-receipts": ["/create-edit-estimates", "/generate-invoice", "/generate-edit-receipt"],
    "/invoice/accounts": ["/invoice/client-info"],
    "/teams-userlist": ["/add-user", "/manage-team-details"],
  };

  const isActive = (path) => {
    // 1. Direct match
    if (location.pathname === path) {
      // console.log('Matched directly:', path);
      return true;
    }

    // 2. Check if location.pathname exists in equivalentPaths (as a key)
    if (equivalentPaths[location.pathname]?.includes(path)) {
      // console.log('Matched as equivalent path:', path, 'for', location.pathname);
      return true;
    }

    // 3. Check if location.pathname is in any equivalentPaths values
    for (const [key, values] of Object.entries(equivalentPaths)) {
      if (values.includes(location.pathname) && key === path) {
        // console.log('Matched reverse equivalent path:', key, 'for', location.pathname);
        return true;
      }
    }

    return false;
  };


  // const isActive = (path) => {
  //   console.log('location.pathname',location.pathname,'path:-',path, 'boolean:-',location.pathname === path)
  //   return location.pathname === path
  // };

  const servicesPermissions = userPermissions?.services?.per_name_sub_json || {};
  const servicesSettingsPermissions = userPermissions?.services_sett?.per_name_sub_json || {};
  const empMgmtPermissions = userPermissions?.emp_mgmt?.per_name_sub_json || {};
  const addOnsPermissions = userPermissions?.add_ons?.per_name_sub_json || {};
  const invoicesPermissions = userPermissions?.invoices?.per_name_sub_json || {};
  const invoiceSettingsPermissions = userPermissions?.invoice_settings?.per_name_sub_json || {};
  const empMgmtSettingsPermissions = userPermissions?.emp_mgmt_settings?.per_name_sub_json || {}
  const leaveMgmtPermissions = userPermissions?.leave_mgmt?.per_name_sub_json || {}
  const expenseMgmtPermissions = userPermissions?.expense_mgmt?.per_name_sub_json || {}
  const contactCenterPermissions = userPermissions?.config?.per_name_sub_json || {}

  const isServicesEnabled = servicesPermissions?.view_service_dashboard === 1 ||
    Object.keys(servicesSettingsPermissions).some(key =>
      ["client_list", "group_master", "manage_services", "others_bulk_update_client_info", "others_import_master", "others_manage_nature_of_calls"].includes(key) && servicesSettingsPermissions[key] === 1
    );

  const isServicesSettingsEnabled = Object.keys(servicesSettingsPermissions).some(key =>
    ["client_list", "group_master", "manage_services", "others_bulk_update_client_info", "others_import_master", "others_manage_nature_of_calls"].includes(key) && servicesSettingsPermissions[key] === 1
  );

  const isOthersEnabled = Object.keys(servicesSettingsPermissions).some(key =>
    ["others_bulk_update_client_info", "others_import_master", "others_manage_nature_of_calls"].includes(key) && servicesSettingsPermissions[key] === 1
  );

  const isEmpMgmtEnabled = empMgmtPermissions?.manage_emp_add_edit_emp === 1 || empMgmtPermissions?.manage_teams_add_edit_emp === 1;
  const isEmpSettingEnabled = empMgmtSettingsPermissions?.leave_config === 1 || empMgmtSettingsPermissions?.manage_nature_expense === 1 || empMgmtSettingsPermissions?.exp_mgmt_open_bal === 1;
  const isLeadveEnabled = leaveMgmtPermissions?.approve_leave === 1 || leaveMgmtPermissions?.leave_req === 1 || leaveMgmtPermissions?.punch_in_out === 1;
  const isExpenseEnabled = expenseMgmtPermissions?.acc_dashboard === 1 || expenseMgmtPermissions?.appr_expense_disburse === 1 || expenseMgmtPermissions?.disbursement_req === 1 || expenseMgmtPermissions?.expense_req === 1;
  const isContactEnabled = contactCenterPermissions?.cont_center === 1 || contactCenterPermissions?.cont_center_edit === 1 || contactCenterPermissions?.cont_center__delete === 1
  const isReminderEnabled = contactCenterPermissions?.reminder_reg_email === 1 || contactCenterPermissions?.reminder_reg_sms === 1 || contactCenterPermissions?.reminder_reg_whatsapp === 1

  const isAddOnsEnabled = Object.keys(addOnsPermissions).some(key =>
    ["nb_add", "nb_edit_del", "dsc_add", "dsc_edit_delete"].includes(key) && addOnsPermissions[key] === 1
  );

  const isNoticeBoardEnabled = Object.keys(addOnsPermissions).some(key =>
    ["nb_add", "nb_edit_del"].includes(key) && addOnsPermissions[key] === 1
  );

  const isDSCCenterEnabled = Object.keys(addOnsPermissions).some(key =>
    ["dsc_add", "dsc_edit_delete"].includes(key) && addOnsPermissions[key] === 1
  );

  const isToDoListEnabled = Object.keys(addOnsPermissions).some(key =>
    ["to_do_list"].includes(key) && addOnsPermissions[key] === 1
  );

  const isInvBillReceiptEstimateEnabled = Object.keys(invoicesPermissions).some(key =>
    ["estimate_create", "estimate_edit", "estimate_del", "invoice_create", "invoice_edit", "invoice_del", "receipt_gen", "receipt_edit"].includes(key) && invoicesPermissions[key] === 1
  );

  const isInvoiceSettingsEnabled = Object.keys(invoiceSettingsPermissions).some(key =>
    ["i_s_config", "i_s_narration", "i_s_manage_tax", "i_s_other_settings"].includes(key) && invoiceSettingsPermissions[key] === 1
  );
  // Check if any permission is 1
  const isReportsVisible = Object.values(userPermissions?.progress_card?.per_name_sub_json || {}).some(value => value === 1);
  const isInvoiceReports = Object.values(userPermissions?.inv_report?.per_name_sub_json || {}).some(value => value === 1);



  const navigationItems = [
    {
      title: "Dashboard",
      icon: dashboardIcon,
      path: '/dashboard',
      items: []
    },
    // isServicesEnabled &&
    {
      title: "Services",
      icon: tasksIcon,
      items: [
        servicesPermissions?.view_service_dashboard === 1 &&
        { subtitle: "Service Dashboard", path: "/services/gst-services" },
        isServicesSettingsEnabled &&
        {
          subtitle: "Settings", path: "/settings", subItems: [
            servicesSettingsPermissions?.client_list === 1 && { subtitle: "Client List", path: "/clientlist" },
            servicesSettingsPermissions?.group_master === 1 && { subtitle: "Group Master", path: "/services/manage-group" },
            servicesSettingsPermissions?.manage_services === 1 && { subtitle: "Manage Services", path: "/task-management-list" },
            isOthersEnabled && { subtitle: "Others", path: "/services/other-settings" },
          ].filter(Boolean)
        },
      ].filter(Boolean)
    },
    {
      title: "Invoices",
      icon: billingIcon,
      items: [
        isInvBillReceiptEstimateEnabled && { subtitle: "Bills/Receipt/Estimate", path: "/bills-receipts" },
        invoicesPermissions?.accounts === 1 && { subtitle: "Accounts", path: "/invoice/accounts" },
        isInvoiceReports && { subtitle: "Reports", path: "/invoice/reports" },
        isInvoiceSettingsEnabled && { subtitle: "Settings", path: "/invoice/settings" }
      ].filter(Boolean)
    },
    {
      title: "Progress Card",
      icon: cardIcon,
      items: [
        isReportsVisible && { subtitle: "Reports", path: "/progress-reports" },
        // { subtitle: "Settings", path: "/settings" }
      ].filter(Boolean)
    },
    // isEmpMgmtEnabled && 
    {
      title: "Employee Mgmt.",
      icon: userIcon,
      items: [
        isEmpMgmtEnabled && { subtitle: "Add/Edit Employee", path: "/teams-userlist" },
        isLeadveEnabled && { subtitle: "Leave Management", path: "/leave-management" },
        isExpenseEnabled && { subtitle: "Expense Management", path: "/expense-management" },
        isEmpSettingEnabled && { subtitle: "Settings", path: "/user/emp-mgmt-settings" }
      ].filter(Boolean)
    },
    {
      title: "Add On’s",
      icon: pluseIcon,
      items: [
        isNoticeBoardEnabled && { subtitle: "Notice Board", path: "/notice-board" },
        isDSCCenterEnabled && { subtitle: "DSC Center", path: "/dsc-center" },
        isToDoListEnabled && { subtitle: "To Do List", path: "/to-do" },
        // { subtitle: "Income Tax Portal", path: "/income-tax-portal" },
        // { subtitle: "Settings", path: "/settings" }
      ].filter(Boolean)
    },
    {
      title: "Configuration",
      icon: settingIcon,
      items: [
        { subtitle: "Contacts Center", path:isContactEnabled && "/configuration/contact-center" },
        { subtitle: "Activity Register", path:contactCenterPermissions?.activity_register === 1 &&  "/configuration/activity-register" },
        { subtitle: "Reminder Register", path:isReminderEnabled &&  "/configuration/reminder-register" },
        { subtitle: "Template Center", path:contactCenterPermissions?.template_center === 1 &&  "/configuration/template-center" },
        { subtitle: "Config Center", path:contactCenterPermissions?.config_center === 1 &&  "/configuration/config-center" },
        // { subtitle: "Settings", path: "/settings" }
      ].filter(Boolean)
    },
    {
      title: "Document Rack",
      icon: DocumentIcon,
      items: [
        { subtitle: "Documents", path: "/documents" },
        // { subtitle: "Settings", path: "/settings" }
      ]
    },
    // {
    //   title: "Settings *",
    //   icon: setting2Icon,
    //   path: '/admin-settings',
    //   items:[]
    // },
    // {
    //   title: "Billing & Payments *",
    //   icon: billingIcon,
    //   path: '/billing-payment-list',
    //   items: []
    // },
  ].filter(Boolean);



  const handleMenuShowHide = () => {
    //console.log('sgokhh')
    setIsMenuShow(!isMenuShow);
    onValueChange(!isMenuShow);
    setActiveDropdown(null);
  }
  const [activeDropdown, setActiveDropdown] = useState(null);
  const handleDropdownToggle = (title) => {
    setActiveDropdown(activeDropdown === title ? null : title);
  };
  const handleNavigation = (path) => {
    // setActiveDropdown(null)
    navigate(path); // Navigate to the given path
    if (isMenuShow) {
      setActiveDropdown(null)
    }
    if (isOverlay) {
      toggleOverlay();
    }
    handleToCheckSessionExpired()
  };

  const handleToCheckSessionExpired = () => {
    const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
    // console.log('storedUserInfo:-',storedUserInfo)
    isTokenExpired(storedUserInfo?.emp_tkn_id, storedUserInfo?.emp_role)

  }

  const handleSubDropdownToggle = (title) => {
    setActiveSubDropdown(activeSubDropdown === title ? null : title);
  };

  const isTokenExpired = async (token, user_role) => {
    // console.log("Token and User Role:", token, user_role);

    try {
      if (!token) {
        console.error("No token provided.");
        return false; // No token means it's effectively expired
      }

      console.log("Decoding token...");
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      const decodedToken = JSON.parse(jsonPayload);

      // console.log("Decoded Token:", decodedToken);

      // Get current time in seconds
      const currentTime = Math.floor(Date.now() / 1000);
      const expTime = decodedToken.exp;

      if (!expTime) {
        console.error("Token does not contain an 'exp' field.");
        return false; // Invalid token structure
      }

      console.log(`Current Time: ${new Date(currentTime * 1000).toString()}`);
      console.log(`Token Expiration Time: ${new Date(expTime * 1000).toString()}`);

      if (currentTime >= expTime) {
        console.log("Token has expired.");
        await callRefreshToken(); // Attempt to refresh the token
        return true;
      } else {
        console.log("Token is still valid.");
        const refreshTime = expTime - 60 * 60; // 1 hour before expiration
        const delay = (refreshTime - currentTime) * 1000;

        if (delay > 0) {
          console.log(`Token refresh scheduled in ${delay / 1000} seconds.`);
          // You can add a timer to refresh the token proactively
          setTimeout(() => callRefreshToken(), delay);
        }
        return false;
      }
    } catch (error) {
      console.error("Error while checking token expiration:", error);
      return false; // Assume expired if an error occurs
    }
  };



  const callRefreshToken = async () => {
    try {
      console.log('callRefreshToken : ');
      const userDetails = JSON.parse(localStorage.getItem('_userInfo_'));
      console.log('userDetails : ', userDetails)
      const payload = {
        "user_id": userDetails?.emp_id,
        "rt": userDetails?.emp_tkn_rf
      }
      console.log('payload', payload);
      // handleLogout();
      return

      const responseData = await postDataLogin(REFRESH_TOKEN, payload);
      if (!responseData) {
        throw new Error('Login failed');
      }
      const response = await responseData?.data;
      console.log('responseData', response);
      // setLoading(false)
      if (response?.statusCode === 200) {
        if (response?.message.toLowerCase() === 'success') {
          if (response?.dataJ.length > 0) {
            userDetails[0].emp_tkn_id = response?.dataJ[0].emp_tkn_id;
            console.log("userDetails[0].it", userDetails[0].emp_tkn_id)
            localStorage.setItem('_userInfo_', userDetails);
            const parsedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            console.log("parsedUserInfo call refresh", parsedUserInfo)


          } else {
            console.log('callRefreshToken tokenlen ', response?.info);
          }
        } else {
          console.log('callRefreshToken fail ', response?.info);
        }
      } else {
        console.log('callRefreshToken catch ', response);
      }
    } catch (e) {
      console.log('callRefreshToken catch ', e);
    }
  }
  const [profileImg, setProfileImg] = useState(profileImg2);
  const [showOptions, setShowOptions] = useState(false);
  const fileInputRef = useRef(null); // Reference to hidden file input
  const [uploadError, setUploadError] = useState('');
  const [uploadLoading, setUploadLoading] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const getProfileImage = async () => {
    setLoading(true);
    setUploadError('');
    const storedUserInfo = JSON.parse(localStorage.getItem("_userInfo_"));
    const pageName = "ProfileImageController";

    try {
      const payload = {
        emp_id_auth: storedUserInfo?.emp_id,
        action: "get"
      };

      console.log("getProfileImage payload", payload);

      const response = await postData(UPLOAD_EMP_PROFILE_URL, payload);
      const responseData = await response.json();

      if (response?.status === 200) {
        if (responseData?.statusCode === 200 && responseData?.message?.toLowerCase() === "success") {
          if (responseData?.dataJ?.length > 0) {
            const imageUrl = await responseData?.dataJ[0]?.photoUrl;
            if (imageUrl) {
              setProfileImg(imageUrl); // Update your profile image state
            } else {
              setProfileImg(profileImg2); // Default image fallback
              setUploadError(responseData?.info || "No profile image found.");
            }
          } else {
            setProfileImg(profileImg2);
            setUploadError(responseData?.info || "No profile image found.");
          }
        } else {
          setProfileImg(profileImg2);
          setUploadError(responseData?.info || "Failed to fetch profile image.");
          logFrontendException(storedUserInfo?.emp_id, pageName, "getProfileImage:message", responseData);
        }
      } else {
        setProfileImg(profileImg2);
        setUploadError("Failed to fetch profile image.");
        logFrontendException(storedUserInfo?.emp_id, pageName, "getProfileImage:api_failed", responseData);
      }
    } catch (error) {
      setProfileImg(profileImg2);
      setUploadError("Network error. Please try again.");
      logFrontendException(storedUserInfo?.emp_id, pageName, "getProfileImage:exception", error);
    } finally {
      setLoading(false);
      setTimeout(() => {
        setUploadError('')
      }, 4000);
    }
  };


  const handleFileUpload = (e) => {
    setUploadError('')
    const file = e.target.files[0];
    const fileName = file.name;
    const fileSize = file.size; // File size in bytes
    const maxFileSize = 1 * 1024 * 1024;
    if (fileSize > maxFileSize) {
      setUploadError("File size exceeds 1MB limit.");
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      setTimeout(() => {
        setUploadError('')
      }, 4000);
      return;
    }
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const fileBase64 = reader.result;
        setProfileImg(fileBase64); // Update UI immediately
        handleProfileImage(fileBase64, false, fileName); // Upload to API
      };
      reader.readAsDataURL(file);
    }
  };


  const handleRemovePhoto = () => {
    handleProfileImage(null, true, ''); // Remove via API
  };

  const handleProfileImage = async (fileBase64 = null, isRemove = false, fileName) => {
    setUploadLoading(true);
    setUploadError('');
    const storedUserInfo = JSON.parse(localStorage.getItem("_userInfo_"));
    const pageName = "ProfileImageController";

    try {
      const payload = {
        emp_id_auth: storedUserInfo?.emp_id,
        action: isRemove ? "remove" : "upload",
      };

      if (!isRemove) {
        if (!fileBase64) {
          setUploadError("No file selected for upload.");
          setUploadLoading(false);
          return;
        }
        payload.profile_file_name = fileName || "profile_image.png"; // You can get actual filename if needed
        payload.profile_base_64 = fileBase64.split(',')[1]; // Remove "data:image/png;base64," part
      }

      console.log("handleProfileImage payload", payload);

      const response = await postData(UPLOAD_EMP_PROFILE_URL, payload);
      const responseData = await response.json();

      if (response?.status === 200) {
        if (responseData?.statusCode === 200 && responseData?.message?.toLowerCase() === "success") {
          if (!isRemove) {
            console.log("Profile image uploaded successfully");
            // Optionally fetch the new image or use responseData?.dataJ
            setProfileImg(fileBase64);
          } else {
            console.log("Profile image removed successfully");
            setProfileImg(profileImg2); // Reset to default
          }
        } else {
          setUploadError(responseData?.info || "Failed to update profile image.");
          logFrontendException(storedUserInfo?.emp_id, pageName, "handleProfileImage:message", responseData);
        }
      } else {
        setUploadError("API call failed.");
        logFrontendException(storedUserInfo?.emp_id, pageName, "handleProfileImage:api_failed", responseData);
      }
    } catch (error) {
      setUploadError("Network error. Please try again.");
      logFrontendException(storedUserInfo?.emp_id, pageName, "handleProfileImage:exception", error);
    } finally {
      setUploadLoading(false);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      setTimeout(() => {
        setUploadError('')
      }, 4000);
    }
  };


  const triggerFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); // Programmatically trigger the file input click
    }
  };
  return (
    <div className={`sidebar ${isOverlay ? 'overlay' : ''}`}
      ref={ref}
      style={{
        width: isOverlay ? '250px' : isMenuShow ? '50px' : '18%',
        position: isOverlay ? 'fixed' : 'static',
        zIndex: isOverlay ? 9999 : 'auto',
        transition: 'transform 0.3s ease',
        transform: isOverlay ? 'translateX(0)' : '',
      }}>

      {/* Company Info */}
      <div style={{ display: 'flex', alignItems: 'center', width: '100%', paddingTop: 40 }}>
        <div className="companyInfo-sty">
          {/* <img className="smallLogo-Sty" src={userInfo?.logo_url || logo} alt="Company Logo"/> */}
          <img
            className="sidebar-smallLogo-Sty"
            src={imageSrc || logo}
            alt="Company Logo"
            onError={() => setImageSrc(logo)} // If image fails to load, use logo
          />
          <h3 className="companyname-Sty" style={{ display: isMenuShow && screenSize.width > 768 ? 'none' : 'block' }}>{userInfo?.emp_company_name}</h3>
        </div>
        <img onClick={handleMenuShowHide} className="menu-icon-sty" src={menuIcon} alt="Company Logo" style={{ display: screenSize.width <= 768 ? 'none' : 'block', transform: isMenuShow ? 'rotate(0deg)' : 'rotate(180deg)', cursor: 'pointer', filter: userInfo?.org_ui_template_id === 4 ? 'brightness(1) invert(1)' : 'brightness(0) invert(1)' }} />

      </div>
      <div className='display-full-height' style={{ width: screenSize.width <= 768 ? '100%' : '80%' }}>

        {/* Profile Section */}
        {/* <div className="sidebar-profile" style={{ paddingTop: 30 }}>
          <img src={profileImg} alt="Profile" className={isMenuShow ? "profile-image-min" : "profile-image"} />
          <h3 className='user-name-sidebar' style={{ display: isMenuShow ? 'none' : 'block' }}>{userInfo?.emp_name}</h3>
          <p style={{ color: 'var(--sidemenu-role-text-color)', fontSize: '14px', marginTop: '6px', display: isMenuShow ? 'none' : 'block' }}>{userInfo?.emp_role}</p>
        </div> */}
        <div className="sidebar-profile" style={{ paddingTop: 30, position: 'relative' }}
          onMouseEnter={() => setShowOptions(true)}
          onMouseLeave={() => setShowOptions(false)}>

          <label>
            <img
              src={profileImg}
              alt="Profile"
              loading="lazy"
              className={isMenuShow ? "profile-image-min" : "profile-image"}
              style={{ cursor: 'pointer', opacity: showOptions ? 0.8 : 1, filter: showOptions ? 'blur(3px)' : 'none' }}
              title={!profileImg || profileImg === profileImg2 ? "Upload" : "Change/Remove"}
            />
          </label>
          {showOptions && profileImg !== profileImg2 && (
            <div className="profile-action-container" style={{ width: isMenuShow ? '' : '100%' }}>
              <button className="profile-action-btn" style={{ opacity: uploadLoading ? 0.5 : 1 }} onClick={triggerFileInput} disabled={uploadLoading}>
                <span className='flexdisplay'>      <img
                  src={galleryIcon}
                  alt="Profile"
                  style={{ cursor: 'pointer', width: 12 }}
                  title={'Gallery'}
                /> {isMenuShow ? '' : 'Change'}</span>
              </button>
              <button className="profile-action-btn remove" style={{ opacity: uploadLoading ? 0.5 : 1 }} onClick={handleRemovePhoto} disabled={uploadLoading}>
                <span className='flexdisplay'>      <img
                  src={removeIcon}
                  alt="Profile"
                  style={{ cursor: 'pointer', width: 12 }}
                  title={'Remove'}
                /> {isMenuShow ? '' : 'Remove'}</span>
              </button>

            </div>
          )}
          <input
            id="orgProfileUpload"
            type="file"
            accept="image/*"
            style={{ display: 'none' }}
            onChange={handleFileUpload}
            ref={fileInputRef} // Link to useRef
          />


          {showOptions && profileImg === profileImg2 && (
            <div className={isMenuShow ? "cam-div-min" : "cam-div"} onClick={triggerFileInput}>
              {/* <span style={{color:'#fff',display:'flex',alignItems:'center',gap:5}}> +  */}
              <img
                src={cameraIcon}
                alt="Profile"
                className={isMenuShow ? "profile-image-min-cam" : "profile-image-cam"}
                style={{ cursor: 'pointer' }}
                title={'Add Image'}
                onMouseEnter={() => setShowOptions(true)}
                onMouseLeave={() => setShowOptions(false)}
              />
              {/* </span> */}
            </div>
          )}
          {uploadLoading && <div className={isMenuShow ? "cam-div-min" : "cam-div"}>
            <Loader loading={true} color={'#000'} size='small' />
          </div>}
          {loading && <div className={isMenuShow ? "cam-div-min" : "cam-div"}>
            <Loader loading={true} color={'#000'} size='small' />
          </div>}
          {uploadError && <div style={{ color: '#ff4848', textAlign: 'center', fontSize: 10 }}> {uploadError} </div>}

          <h3 className='user-name-sidebar' style={{ display: isMenuShow && screenSize.width > 768 ? 'none' : 'block' }}>{userInfo?.emp_name}</h3>
          <p style={{ color: 'var(--sidemenu-role-text-color)', fontSize: '14px', marginTop: '6px', display: isMenuShow && screenSize.width > 768 ? 'none' : 'block' }}>{userInfo?.emp_role}</p>
        </div>

        {/* Dropdown section*/}
        <div className={isMenuShow && activeDropdown ? "sidebar-menu-active sidebar-menu" : "sidebar-menu"} style={{ paddingTop: 20 }}>
          {/* {!isMenuShow && (
            <div style={{ ...styles.searchBox }}>
              <img src={searchIcon} alt="Search Icon" style={styles.searchIcon} />
              <input
                type="text"
                style={styles.searchInput}
                placeholder="Search Items..."
              />
            </div>
          )} */}
          {navigationItems.map((navItem) => {
            // Check if any sub-item is active  
            const isParentActive = false;
            // navItem.items?.some(item =>
            //   isActive(item.path) || item.subItems?.some(subItem => isActive(subItem.path))
            // );

            return (
              <div key={navItem.title} className="dropdown">
                <button
                  className={`sidebar-menu-li ${isActive(navItem.path) || isParentActive ? 'active' : ''}`}
                  onClick={() =>
                    navItem?.items?.length
                      ? handleDropdownToggle(navItem?.title)
                      : (handleNavigation(navItem?.path), setActiveDropdown(null))
                  }
                >
                  <img
                    src={navItem?.icon}
                    alt={navItem?.title}
                    className={`sidebar-icon ${isActive(navItem.path) || isParentActive ? 'sidebar-icon-white' : 'icon-color-sidebar'}`}
                  />
                  <span className={`dropdown-title ${isActive(navItem.path) || isParentActive ? 'sidebar-Active' : ''}`}
                    style={{ display: isMenuShow && !activeDropdown && !isOverlay ? 'none' : 'block' }}>
                    {navItem?.title}
                  </span>
                  <span className="dropdown-arrow">
                    {navItem.title !== "Dashboard" && (
                      <img className="down-icon-sty" src={downArrowIcon} alt="Company Logo"
                        style={{
                          transform: activeDropdown === navItem.title ? 'rotate(180deg)' : 'rotate(0deg)',
                          display: isMenuShow && !activeDropdown && !isOverlay ? 'none' : 'block',
                          filter: userInfo?.org_ui_template_id === 4 ? 'none' : 'brightness(0) invert(1)'
                        }} />
                    )}
                  </span>
                </button>

                {/* Sub-Items  || item.subItems?.some(subItem => isActive(subItem.path))*/}
                {activeDropdown === navItem.title &&
                  navItem.items.map((item, idx) => {
                    const isSubItemActive = isActive(item.path);

                    return (
                      <div key={idx}>
                        <div
                          className={`dropdown-link ${isSubItemActive ? "sub-active" : "sub-inactive"}`}
                          style={{ paddingLeft: 30, cursor: "pointer", alignItems: 'center', display: 'flex', justifyContent: 'space-between', lineBreak: 'anywhere' }}
                          onClick={() =>
                            item.subItems
                              ? handleSubDropdownToggle(item.subtitle)
                              : handleNavigation(item.path)
                          }
                        >
                          <span>{item.subtitle}</span>
                          {item?.subItems?.length > 0 && (
                            <img className="down-icon-sty" src={downArrowIcon} alt="Company Logo"
                              style={{ transform: activeSubDropdown === item.subtitle ? 'rotate(180deg)' : 'rotate(0deg)', filter: userInfo?.org_ui_template_id === 4 ? 'none' : 'brightness(0) invert(1)' }} />
                          )}
                        </div>

                        {activeSubDropdown === item.subtitle &&
                          item.subItems?.map((subItem, subIdx) => (
                            <div
                              key={subIdx}
                              className={`dropdown-link-sub ${isActive(subItem.path) ? "sub-active" : "sub-inactive"}`}
                              style={{
                                paddingLeft: 30,
                                color: isActive(subItem.path) ? "var(--sidemenu-selected-text-color)" : "",
                                cursor: "pointer",
                              }}
                              onClick={() => handleNavigation(subItem.path)}
                            >
                              {subItem.subtitle}
                            </div>
                          ))}
                      </div>
                    );
                  })}
              </div>
            );
          })}


          {/* Logout Section */}
          <div className="sidebar-logout" style={{ padding: isMenuShow ? '20px 0px' : '15px' }}>
            <button onClick={logout} className="center-alin-sty" style={{ justifyContent: isMenuShow ? 'center' : '' }}>
              <img src={logoutIcon} alt="Logout" className="logout-icon" style={{ filter: userInfo?.org_ui_template_id === 4 ? 'brightness(1) invert(1)' : 'brightness(0) invert(1)' }} />
              <span style={{ display: isMenuShow && !isOverlay ? 'none' : 'block', paddingLeft: 10 }}>Log out</span>
            </button>
          </div>
        </div>
      </div>

    </div>
  );
});

export default Sidebar;

const styles = {
  searchBox: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'var(--sidemenu-dd-bg-color)',
    borderRadius: '30px',
    padding: '8px 20px',
    // width: '70%',
    margin: 'auto'
  },
  searchIcon: {
    width: '15px',
    height: '15px',
    marginRight: '10px', // Space between the icon and input field
    filter: 'invert(63%) sepia(11%) saturate(384%) hue-rotate(163deg) brightness(90%) contrast(85%)',
  },
  searchInput: {
    border: 'none',
    background: 'none',
    outline: 'none',
    color: 'var(--sidemenu-user-info-color)',
    fontSize: '10px',
    width: '80%',
    fontStyle: 'italic',
  },
};
